import { inject, singleton } from 'tsyringe';
import { Category } from 'typescript-logging-category-style';
import { kDITokenLogger } from '../constants/injectionTokens';
import { ILogger } from '../interfaces/logger.interface';

// -----------------------------------------------------------------------------
@singleton()
export class LoggerBaseService {
  static logger: ILogger;
  // ---------------------------------------------------------------------------
  constructor(@inject(kDITokenLogger) protected readonly logger: ILogger) {
    LoggerBaseService.logger = logger;
  }

  // ---------------------------------------------------------------------------
  static assignCustomLogger(category: Category) {
    if (
      typeof process === 'undefined' ||
      typeof LoggerBaseService?.logger?.info === 'undefined'
    ) {
      return false;
    }

    category.debug = (...message) =>
      LoggerBaseService.logger.debug(this.mapLogMessage(category, ...message));

    category.error = (...message) =>
      LoggerBaseService.logger.error(this.mapLogMessage(category, ...message));

    category.info = (...message) =>
      LoggerBaseService.logger.info(this.mapLogMessage(category, ...message));

    category.trace = (...message) =>
      LoggerBaseService.logger.trace(this.mapLogMessage(category, ...message));

    category.warn = (...message) =>
      LoggerBaseService.logger.warn(this.mapLogMessage(category, ...message));

    return true;
  }

  // ---------------------------------------------------------------------------
  private static mapLogMessage(category: Category, ...message: string[]) {
    return `[${category.name}] ${message.join(' - ')}`;
  }
}
